// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2nY84","modalForm":"UpgradeEpcsModal_modalForm__2k14w","modalFooter":"UpgradeEpcsModal_modalFooter__1y_kL"};